// extracted by mini-css-extract-plugin
export default {"card":"style_card__74bqo","activeCard":"style_activeCard__IoF6W"};